import L from "leaflet";

/**
 * Fix Leaflet default marker icon paths (broken in Webpack/CRA bundling).
 * Import this module once (e.g. in Dashboard) so markers use public/leaflet-images/
 * instead of broken unpkg URLs.
 */
function fixLeafletDefaultIcons() {
  delete (L.Icon.Default.prototype as any)._getIconUrl;
  L.Icon.Default.mergeOptions({
    iconUrl: `${process.env.PUBLIC_URL || ""}/leaflet-images/marker-icon.png`,
    iconRetinaUrl: `${process.env.PUBLIC_URL || ""}/leaflet-images/marker-icon-2x.png`,
    shadowUrl: `${process.env.PUBLIC_URL || ""}/leaflet-images/marker-shadow.png`,
  });
}

fixLeafletDefaultIcons();
